"use client";

import React from "react";
import { Linkedin, Twitter, Instagram, MapPin, Phone, Mail, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
export default function Footer() {
  const currentYear = new Date().getFullYear();
  const ctaButtons = [{
    label: "Start Exploring the Platform",
    variant: "default" as const,
    icon: true
  }, {
    label: "Watch the Demo",
    variant: "outline" as const,
    icon: false
  }, {
    label: "Explore Profissa Pro™",
    variant: "secondary" as const,
    icon: false
  }];
  return <section id="footer" className="dark bg-background text-foreground py-16 lg:py-20 border-t border-border/10">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          <div className="flex flex-col gap-6">
            <Link to="/HomePage#" className="inline-block transition-opacity hover:opacity-80">
              <div className="flex items-center">
                
              </div>
            </Link>
            <p className="text-muted-foreground leading-relaxed text-sm">
              Profissa Pro™ is a financial intelligence platform designed for service professionals and project‑based businesses that need clarity about real profitability.
            </p>
          </div>

          
          <div className="flex flex-col gap-6">
            <h3 className="font-semibold text-lg tracking-tight text-foreground">Quick Links</h3>
            <nav className="flex flex-col gap-3">
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm w-fit">
                Services
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm w-fit">
                About Us
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm w-fit">
                Results
              </Link>
              <Link to="#" className="text-muted-foreground hover:text-primary transition-colors text-sm w-fit">
                Careers
              </Link>
            </nav>
          </div>

          
          <div className="flex flex-col gap-6">
            <h3 className="font-semibold text-lg tracking-tight text-foreground">Contact</h3>
            <div className="flex flex-col gap-4 text-sm text-muted-foreground">
              <div className="flex items-start gap-3">
                <MapPin className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <span>
                  Miami, Florida – USA
                </span>
              </div>
              <div className="flex items-start gap-3">
                <Phone className="h-5 w-5 text-primary shrink-0 mt-0.5" />
                <Link to="tel:+17865099691" className="hover:text-foreground transition-colors">
                  Phone – Profissa Pro Support +1 (786) 509-9691
                </Link>
              </div>
              <div className="flex items-center gap-3">
                <Mail className="h-5 w-5 text-primary shrink-0" />
                <Link to="mailto:contact@profissapro.com" className="hover:text-foreground transition-colors">
                  contact@profissapro.com
                </Link>
              </div>
            </div>
          </div>

          
          <div className="flex flex-col gap-6">
            <h3 className="font-semibold text-lg tracking-tight text-foreground">Get Started</h3>
            <div className="flex flex-col gap-3">
              {ctaButtons.map((button, i) => <Button key={i} data-index={i} variant={button.variant} className="w-full justify-between">
                  {button.label}
                  {button.icon && <ArrowRight className="h-4 w-4" />}
                </Button>)}
            </div>
          </div>
        </div>

        

        
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-sm text-muted-foreground">
          <div className="flex flex-col md:flex-row items-center gap-4 md:gap-8 text-center md:text-left">
            <p>© {currentYear} Profissa Pro™. All rights reserved.</p>
            <div className="flex gap-6 justify-center md:justify-start">
              <Link to="#" className="hover:text-foreground transition-colors">
                Privacy
              </Link>
              <Link to="#" className="hover:text-foreground transition-colors">
                Terms
              </Link>
              <Link to="https://www.instagram.com/profissapro.2026" newTab className="hover:text-foreground transition-colors">
                Follow Profissa Pro on Instagram
              </Link>
            </div>
          </div>

          <div className="flex items-center gap-4">
            <Link to="https://linkedin.com" newTab className="p-2 rounded-full hover:bg-accent hover:text-foreground transition-all duration-300 text-muted-foreground" aria-label="LinkedIn">
              <Linkedin className="h-5 w-5" />
            </Link>
            <Link to="https://twitter.com" newTab className="p-2 rounded-full hover:bg-accent hover:text-foreground transition-all duration-300 text-muted-foreground" aria-label="X (Twitter)">
              <Twitter className="h-5 w-5" />
            </Link>
            <Link to="https://instagram.com" newTab className="p-2 rounded-full hover:bg-accent hover:text-foreground transition-all duration-300 text-muted-foreground" aria-label="Instagram">
              <Instagram className="h-5 w-5" />
            </Link>
          </div>
        </div>
      </div>
    </section>;
}